import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Factura } from 'src/app/Models/factura/factura';
import { DataService } from 'src/app/Service/data.service';

@Component({
  selector: 'app-table-row',
  templateUrl: './table-row.component.html',
  styleUrls: ['./table-row.component.css']
})
export class TableRowComponent implements OnInit {
  @Input() cliente?;
  @Input() documen?;
  @Input() hora?;
  @Input() item;
  @Output() event: EventEmitter<number> = new EventEmitter<number>();
  isselect:boolean = false;
  constructor(private route: Router, private data:DataService) { 

  }

  ngOnInit() {
  }
  mouseenter(){
    this.isselect = true;
  }
  mouseleave(){
    this.isselect = false;
  }
  selected(){
    //console.log(this.item);
    this.route.navigateByUrl('/printer/pedido/' + this.documen);
  }
  entregado(){
    let entrega = {entrega:1}
    this.data.Put(this.data.api.factura,this.documen,entrega).subscribe((data)=>{console.log(data)},(error)=>{console.log(error)})
  }


}
